import { MinzeElement } from "minze";

export interface TjHeartIcon {}

export class TjHeartIcon extends MinzeElement {
  html = () => `
    <svg width="46" height="44" viewBox="0 0 46 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M39.881 25.1215C33.4757 32.9461 17.8578 39.3537 10.8496 41.5794C9.12131 38.9363 5.10729 31.4232 2.87744 22.516C0.09013 11.3819 2.7127 0.158595 14.0322 2.42223C23.0878 4.23314 22.9965 12.5184 21.8189 16.4347C24.0178 12.5356 29.8321 5.19389 35.4983 7.01989C42.5809 9.30239 47.8877 15.3409 39.881 25.1215Z" stroke="#ADE9CF" stroke-width="3" stroke-linejoin="round"/>
    </svg>
  `;

  css = () => `
    
  `;
}
